import React, { Component, useState } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import ExifReader from "exifreader";
import Resizer from "react-image-file-resizer";
import piexif from "piexifjs";
import ReactDOMServer from 'react-dom/server';
import { FormattedMessage, injectIntl } from 'react-intl';
import { parseClasses, generateUUID, i18nIntl, getFileSize, base64ToBytes } from '../../lib/ep.js';
import { isEqual as _isEqual } from 'lodash';

import { SecondaryButton, SquaredButton } from './ActionButton';
import ButtonCollection from './ButtonCollection';
import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';
import FloatingLayer from './FloatingLayer';
import Spinner from './Spinner';
import { DeleteButton } from './ConfirmButton.js';
import SectionTitle from './SectionTitle.js';
import SectionSubtitle from './SectionSubtitle.js';
import FloatingLayerPublic from '../front/FloatingLayerPublic.js';

const placeholder_images = [
	'/img/no-foto_300x180.jpg',
];

var baseComponentConfig = {
	iconFiletypes:['.jpg', '.png', '.gif', '.webp'],
	showFiletypeIcon:true,
	postUrl:'/uploadHandler',
	showFiletypeIcon:false
};

var basedjsConfig = {
	autoProcessQueue:false,
	thumbnailWidth:null,
	thumbnailHeight:null,
	createImageThumbnails:false,
	previewTemplate:ReactDOMServer.renderToStaticMarkup(
		<div>
			<div className="dz-details">
				<img data-dz-thumbnail="true" />
			</div>

			<div className="dz-progress">
				<span className="dz-upload" data-dz-uploadprogress="true" />
			</div>
		</div>
	),
};

const allowed = {
	'image/jpeg':1,
	'image/gif':1,
	'image/png':1,
	'image/webp':1,
}

const successUpload = (k, props, response,name) => {
	if(response.status) {
		let full = `full_${k}`;
		if(props.changeMulti) {
			if (response.name == undefined) response.name = "";
			if (response.full == undefined) response.full = "";

			props.changeMulti({
				[k]:response.name,
				[full]:response.full
			});
		} else {
			let fname = response.name ?? "";
			if (response.filename != undefined) {
				fname = response.filename;
			}
			
			props.change(k,fname, name,response.full);
			props.change(`full_${k}`, response.full ?? '',name);
		}

		if(props.hooks != undefined) props.hooks({ type:'AUTO_IMAGE_END', response });
	}
};

export const dataURLtoFile = (dataurl, filename) => {
	var arr = dataurl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);

	while(n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], filename, { type:mime });
};

export const uploadImage = (auto_url, file, cb, props) => {
	const uploadedHandler = (e) => {
		const response = JSON.parse(e.srcElement.response);

		if(cb != undefined) cb(response);
	};

	const formData = new FormData();
	formData.append("image", file);
	if (props?.auto_type) {
		formData.append('type',props.auto_type);
	}
	if(props?._size) {
		if(props._size.fit != undefined)formData.append('fit',props._size.fit);
		if(props._size.width != undefined)formData.append('width',props._size.width);
		if(props._size.height != undefined)formData.append('height',props._size.height);
	}

	if (props?.id) {
		formData.append('id',props.id);
	}

	const ajax = new XMLHttpRequest();
	//ajax.upload.addEventListener("progress", progressHandler, false);
	ajax.addEventListener("load", uploadedHandler, false);
	// ajax.addEventListener("error", errorHandler, false);
	// ajax.addEventListener("abort", abortHandler, false);
	ajax.open("POST", auto_url);
	ajax.send(formData);
}

export const resizeImageDimensions = (width, height, maxWidth = 1200, maxHeight = 1200, minSize = 500) => {

    const minRatio = 2 / 3; // 0.66
    const maxRatio = 3 / 2; // 1.5
    let newWidth = width;
    let newHeight = height;

    //Dins dels limits, no modificar
    if (width <= maxWidth && height <= maxHeight && width >= minSize && height >= minSize) {
        return { width, height };
    }

    const aspectRatio = width / height;

    //Proporcio exagerada, reescalar.
    if (aspectRatio < minRatio || aspectRatio > maxRatio) {
        if (width > height) {
            newWidth = maxWidth;
            newHeight = Math.round(newWidth / aspectRatio);
        } else {
            newHeight = maxHeight;
            newWidth = Math.round(newHeight * aspectRatio);
        }
    } else {
        // Redimensionem sense carregarnos l'aspecte
        if (width > height) {
            newWidth = maxWidth;
            newHeight = Math.round((height / width) * maxWidth);
        } else {
            newHeight = maxHeight;
            newWidth = Math.round((width / height) * maxHeight);
        }
    }

    //Assegurem minims
    if (newWidth < minSize) {
        newWidth = minSize;
        newHeight = Math.round(newWidth / aspectRatio);
    }

    if (newHeight < minSize) {
        newHeight = minSize;
        newWidth = Math.round(newHeight * aspectRatio);
    }

    return { width: newWidth, height: newHeight };
}

export const AutoPostImageUploader = injectIntl((props) => {
	const [ uploading, setUploading ] = useState(false);
	const [ progress, setProgress ] = useState(0);
	const [ sizeError, setSizeError ] = useState(false);

	const change = (k, v,name) => {
		if(k.indexOf('full_') > -1) return;

		if(props.auto_url != undefined) {
			let data = { type:props.auto_type };

			if(v == null && props.image != undefined) {
				props.change(k,v,name);
				props.change(`full_${k}`,v);

				data.name = props.image;
				if(data.name.indexOf('/') > -1) {
					data.name = props.image.split('/').slice(-1)[0];
				}
				$.post(props.auto_url, data, (response) => {
					if(response.status == 0){
						this.setState({ error:response.message})
					}else{
						successUpload(k,props,response);
					}
				}, 'JSON');
			}
		}
	}

	const djsConfig = {
		...basedjsConfig,
		autoProcessQueue:true,
		url:props.auto_url,
		paramName:'image',
	}
	if (props?.max_items) djsConfig.maxFiles = props.max_items;

	const eventHandlers = {
		sending:(file, xhr, formData) => {
			xhr.open('POST', props.auto_url + '/uploadSize_' + (getFileSize(file.size,0).replace(' ','')), true);
			const max_weight = props?._max_weight ?? null;//null BY default
			if(max_weight){
				const max_size_permitted = max_weight * 1024 * 1024;
				if(max_size_permitted < file.size) {
					setSizeError(file.size);
					return;
				}
			}

			setUploading(true);
			setProgress(0);
			if(props.fileAdded != undefined) props.fileAdded(file,xhr,formData);
			if(props.hooks != undefined) props.hooks({ type:'AUTO_IMAGE_START' });
			if(props.image != undefined) {
				formData.append('name',props.image.split('/').slice(-1)[0]);
			}
			formData.append('type',props.auto_type);
			if(props?._size) {
				if(props._size.fit != undefined)formData.append('fit',props._size.fit);
				if(props._size.width != undefined)formData.append('width',props._size.width);
				if(props._size.height != undefined)formData.append('height',props._size.height);
			}
		},
		uploadprogress:(file, percent, bytes) => {
			setProgress(percent);
		},
		success:(file, response) => {
			response = JSON.parse(response);
			successUpload(props.name, props, response, file.name);
			setUploading(false);
		}
	}

	return (
		<>
			<ImageUploader
				{...props}
				djsConfig={djsConfig}
				eventHandlers={eventHandlers}
				progress={progress}
				uploading={uploading}
				componentConfig={{postUrl:props.auto_url}}
				change={change}
			/>
	
			{(sizeError !== false) && (
				<FloatingLayer _class={{ size:'small' }} backButton={() => setSizeError(false)}>
					<div>
						<SectionTitle>The file is too big</SectionTitle>
						<SectionSubtitle autotranslate={false}>
							<FormattedMessage id="You have exceeded the maximum file size{max}" values={{ max:`: ${getFileSize(props._max_weight)}`}} />
						</SectionSubtitle>
		
						<ButtonCollection in_floating={true}>
							<SecondaryButton
								onClick={() => setSizeError(false)}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</>
	)
});

export const AutoImageUploader = injectIntl((props) => {
	const [uploading,setUploading] = useState(false);

	const change = (k, v) => {
		if(k.indexOf('full_') > -1) return;

		if(props.auto_url != undefined) {
			let data = { image:v, type:props.auto_type };
			if(v == null && props.image != undefined) {
				data.name = props.image.split('/').slice(-1)[0];
			} else {
				setUploading(true);
			}

			if(props?._size) {
				if(props._size.fit != undefined) data.fit = props._size.fit;
				if(props._size.width != undefined) data.width = props._size.width;
				if(props._size.height != undefined) data.height = props._size.height;
			}
			
			if(props.hooks != undefined) props.hooks({ type:'AUTO_IMAGE_START' });

			$.post(props.auto_url, data, (response) => {
				if(response.status) {
					setUploading(false);
					let full = `full_${k}`;

					if (props.changeMulti) {
						props.changeMulti({
							[k]:response.name,
							[full]:response.full
						});
					} else {
						props.change(k,response.name ?? "", true);
						props.change(`full_${k}`, response.full ?? '');
					}
					if(props.hooks != undefined) props.hooks({ type:'AUTO_IMAGE_END', response });
				}
			}, 'JSON');
		}
	}

	return (
		<ImageUploader
			{...props}
			uploading={uploading}
			change={change}
		/>
	)
});

const fetchImageAsFile = async (url) => {
    try {
		const response = await fetch(url);
		let blob = await response.blob();

		// Si el tipo MIME no es imagen, intentamos deducirlo del nombre
		let type = blob.type;
		const filename = url.split('/').pop().split('?')[0];
		const extension = filename.split('.').pop().toLowerCase();

		if (!type.startsWith('image/')) {
			// Intentamos corregir el tipo MIME basándonos en la extensión
			const mimeMap = {
				jpg: 'image/jpeg',
				jpeg: 'image/jpeg',
				png: 'image/png',
				gif: 'image/gif',
				webp: 'image/webp',
				bmp: 'image/bmp',
				svg: 'image/svg+xml'
			};
			type = mimeMap[extension] || 'image/jpeg'; // fallback
			blob = new Blob([await blob.arrayBuffer()], { type });
		}
		return new File([blob], filename, { type });
	} catch (err) {
		console.error('Error fetching image from URL:', err);
		return null;
	}
  };

class ImageUploader extends Component {
	constructor(props) {
		super();
		this.state = {
			display_uploaded_image:false,
			error:null,
			exif:props?.exif ?? null,
			allowed:props.allowed!=undefined?props.allowed:allowed,
			image:(props.image != undefined && props.image.indexOf("winner_cup") < 0) ? props.image : '',
		}

		this.uploader_id = generateUUID();

		this.eventHandlers = {};
		this.eventHandlers.addedfile = this.imgAdded.bind(this);

		if (props.eventHandlers!=undefined) {
			this.eventHandlers = {...this.eventHandlers,...props.eventHandlers}
		}

		this.djsConfig = props.djsConfig ?? basedjsConfig;
		this.componentConfig = props.componentConfig ? {...baseComponentConfig,...props.componentConfig} : baseComponentConfig;

		if(props.preview != undefined && !props.preview) this.djsConfig.previewsContainer = false;
		if(props.maxFiles != undefined) this.djsConfig.maxFiles = props.maxFiles;
		//If there is a Children override it

		this.reset_value = '[reset]';	// use this value to reset the uploader and let everything clean
	}

	handleNativeDrop = (e) => {
      const dataTransfer = e.dataTransfer;
      if (dataTransfer && dataTransfer.types.includes('text/uri-list')) {
        e.preventDefault();

        const url = dataTransfer.getData('text/uri-list');
        if(url) {
          fetchImageAsFile(url).then((file) => {
            if (file) {
              this.dropzoneRef.dropzone.addFile(file);
            }
          });
        }
      }
    };

	componentDidMount() {
		if (this.dropzoneRef) {
			this.dropzoneRef.dropzone.element.addEventListener('drop', this.handleNativeDrop, true);
		}

		if(this.props.onRef != undefined) this.props.onRef(this);
	}

	componentWillUnmount() {
		if (this.dropzoneRef) {
			this.dropzoneRef.dropzone.element.removeEventListener('drop', this.handleNativeDrop, true);
		}
		if(this.props.onRef != undefined) this.props.onRef(undefined)
	}

	componentWillReceiveProps(props) {
		if(!_isEqual(props.image, this.state.image)) {
			this.state.image = props.image;
			this.setState({ ...this.state });
		}
	}

	//Load the preview when loading the image
	imgAdded(file) {
		var reader = new FileReader();

		if(this.props.imgSelected) this.props.imgSelected(file.name);

		// NOTE: I think the file is missing into the function
		reader.onload = (e)=>this.onImage(e,file);

		reader.readAsDataURL(file);
	}

	getMimeType = (base64) => {
		//Check for mime type
		const parts = base64.split(';');
		const mime = parts[0].split(':');
		const mimetype = mime[1];
		return mimetype;
	}

	getEXIFData = (b64, resized_b64) => {
		if(resized_b64 == undefined) resized_b64 = b64;
		
		//Check for mime type
		const mimetype = this.getMimeType(resized_b64);

		// Load EXIF ​​data (or create if it doesn't exist)
		let exifData;
		if(['image/jpeg'].includes(mimetype)) {
			try {
				exifData = piexif.load(resized_b64);
			} catch (error) {
				console.warn("No EXIF data found, it will be initialized.");
				exifData = { "0th": {}, "Exif": {}, "GPS": {} }; // Initialize empty EXIF ​​data.
			};
			// Modify or add EXIF ​​data
			exifData["0th"][piexif.ImageIFD.Artist] = "Image Resized Tool from Easypromos Developer";
			exifData["0th"][piexif.ImageIFD.Orientation] = 1;
		}
		return exifData;
	}

	setEXIFData = (resized_b64) => {
		if(!this.state.exif)return resized_b64;
		// Generate the updated EXIF ​​bytes
		const exifBytes = piexif.dump(this.state.exif);

		// Insert EXIF ​​bytes into base64 image
		return piexif.insert(exifBytes, resized_b64);
	}

	onImage = (e, file) => {
		if(!file) return;
		//Check for mime type
		const parts = e.target.result.split(';');
		const mime = parts[0].split(':');
		const extension_format = mime[1].split('/');
		const extension = extension_format[1].toUpperCase();

		if(this.state.allowed[mime[1]] == undefined) {
			this.setState({ error:"Format not allowed", image:'' })
			return;
		} else {
			this.setState({error:null});
		}

		const max_weight = this.props?._max_weight ?? null;//null BY default
		if(max_weight){
			const max_size_permitted = max_weight * 1024 * 1024;
			if(max_size_permitted < file.size) {
				const message_max_weight = this.props.intl.formatMessage({id:"Maximum file size"})+': '+(getFileSize(max_size_permitted));
				this.setState({ error:message_max_weight })
				return;
			}
		}

		const min_weight = this.props?.min_weight ?? null;//null BY default
		if(min_weight && !['PDF'].includes(extension)){//NO control for PDF + IA
			const min_size_allowed = min_weight.size * 1024;
			if(min_size_allowed > file.size) {
				this.setState({ error:min_weight?.error ?? 'too_small' })
				return;
			}
		}
		
		let image_exif_b64;
		const allow_resize = this.props?._resize ?? false;

		// if the file is NOT a JPEG / JPG, simply upload it:
		// (only JPEG files can be resized, otherwise PiEXIF library will crash)
		if(!['JPEG', 'JPG'].includes(extension)) {
			this.uploadAfterResize(e.target.result, file);
			return;
		}

		if(!this.state.exif && this.props.onReadExif != undefined){
			const _exif = this.getEXIFData(e.target.result);
			this.props.onReadExif(_exif);
			this.setState({exif:this.getEXIFData(e.target.result)});
		}

		if(allow_resize === false) {
			image_exif_b64 = this.setEXIFData(e.target.result);
			this.uploadAfterResize(image_exif_b64, file);
			return;
		}

		const img = new Image();
		img.src = e.target.result;
		
		img.onload = () => {
			const _maxwidth = allow_resize?.width ?? 1200;
			const _maxheight = allow_resize?.height ?? 1200;
			let mides = {
				width:(_maxwidth == 'original') ? img.naturalWidth : _maxwidth,
				height:(_maxheight == 'original') ? img.naturalHeight : _maxheight,
			};
			const default_min_global = Math.min(1200,Math.min(mides['width'],mides['height']));
			if(img.naturalWidth && img.naturalHeight){
				mides = resizeImageDimensions(img.naturalWidth, img.naturalHeight, _maxwidth,_maxheight,default_min_global);
			}
			const max_width = mides['width'];
			const max_height = mides['height'];
			const min_width = default_min_global;
			const min_height = default_min_global;
			const quality = 97;

			const compress_format = allow_resize?.extension ?? 'JPEG';//forcem sortida

			try {
				Resizer.imageFileResizer( file,
					max_width,
					max_height, 
					compress_format, 
					quality, 
					0,
					(base64) => {
						if(compress_format.toUpperCase() == 'JPEG'){//Nomes es pot afegir exifs en JPEG
							image_exif_b64 = this.setEXIFData(base64);
							this.uploadAfterResize(image_exif_b64, file);
						}else{
							this.uploadAfterResize(`${base64}`,file);
						}
					},
					"base64",
					min_width,
					min_height);
			} catch (err) {
				image_exif_b64 = this.setEXIFData(e.target.result);
				this.uploadAfterResize(image_exif_b64, file);
			}
		}
	}

	uploadAfterResize(base64,file){
		//console.log("Fitxer Resize: ",getFileSize(base64ToBytes(base64)),base64)
		if(this.props.nopreview == undefined) this.setState({image:base64});
		if(this.props.change != undefined) {
			this.props.change(this.props.name,base64, file.name,this.props.image);
			var full_name = (this.props.full_name == undefined) ? this.getFullNameMedia(this.props.name) : this.props.full_name;
			this.props.change(full_name,base64);
		}
	}


	getFullNameMedia(name) {
		var myname = name.split('.');
		var prev_name = '';
		var full_name = '';
		for(var i = 0; i < myname.length; i++) {
			if(i > 0) prev_name += myname[i - 1] + '.';
			full_name = myname[i];
		}

		return prev_name + `full_${full_name}`;
	}

	emulateClick() {
		$(`#${this.uploader_id} .filepicker`).trigger('click');
	}

	has_preview_file() {
		if(this.props.preview_file == undefined || this.props.preview_file == "") return false;
		return (/^data\:/.test(this.props.preview_file)) ? false : true;
	}

	remove() {
		if(this.props.delete) this.props.delete();
		if(this.props.change != undefined) {
			this.props.change(this.props.name, null,this.state.image);
			var full_name = this.getFullNameMedia(this.props.name);
			this.props.change(full_name, null);
		}
		this.state.image = '';
		this.setState({...this.state});
		if(this.props.onRemove)this.props.onRemove();
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		let size_specs = false;
		const dd_size = this.props?.dd_size ?? 'dynamic';
		let thumb_w = this.props?.thumb_w ?? 300;
		let thumb_prop = 1.618;
		let aspect_ratio = '1 / 1';
		const reduce_placeholder = this.props?.reduce_placeholder ?? true;
		const is_builder = this.props?.is_builder ?? true;
		const is_frontend = this.props?.is_frontend ?? false;

		if(this.props._size) {
			if(this.props._size.fit != undefined) {
				switch(this.props._size.fit) {
					case 'height':
						size_specs = this.props.intl.formatMessage({ id:"height: {size}px" }, { size:this.props._size?.height ?? 1000 });
						break;

					case 'width':
						size_specs = this.props.intl.formatMessage({ id:"width: {size}px" }, { size:this.props._size?.width ?? 1000 });
						break;

					case 'auto':
						size_specs = this.props.intl.formatMessage({ id:"large side: max. {size}px" }, { size:1000 });
						break;

					default:
						size_specs = this.props.intl.formatMessage({ id:"large side: max. {size}px" }, { size:this.props._size?.fit ?? 1000 });
						break;
				}
			} else {
				size_specs = `${this.props._size.width}×${this.props._size.height}px`;
				thumb_prop = this.props._size.width / this.props._size.height;
				aspect_ratio = `${this.props._size.width} / ${this.props._size.height}`;
			}
		}

		const max_size = this.props?.max_size ?? false;
		const _extra = this.props?.label_props?.addition ?? ((size_specs) ? `${size_specs}${(max_size !== false) ? ` (max: ${getFileSize(max_size)})` : ''}` : null);

		const _field_styles = this.props?._field_style ?? {};

		let _style = this.props?.style ?? {};
		//_style.width = `${thumb_w}px`;	// replaced with "aspectRatio"
		//_style.height = `${thumb_w / thumb_prop}px`;	// replaced with "aspectRatio"
		_style.aspectRatio = aspect_ratio;

		let size_class = false;

		if(this.props._thumb_size != undefined) {
			if(this.props._thumb_size.width != undefined && this.props._thumb_size.height == undefined) {
				_style.width = this.props._thumb_size.width;
				_style.height = (this.props._thumb_size.width / thumb_prop);
			} else if(this.props._thumb_size.width == undefined && this.props._thumb_size.height != undefined) {
				_style.width = (this.props._thumb_size.height * thumb_prop);
				_style.height = this.props._thumb_size.height;
			} else {
				_style.width = this.props._thumb_size.width;
				_style.height = this.props._thumb_size.height;
			}

			if(typeof(_style.width) == 'number') _style.width += 'px';
			if(typeof(_style.height) == 'number') _style.height += 'px';

			if(reduce_placeholder) {
				if(typeof(_style.width) == 'string') {
					// we assume there is a value unit in the "width" attribute (i.e. "100%"):
					_style.width = `calc(${_style.width} - 6px)`;
				}

				if(typeof(_style.height) == 'string') {
					// we assume there is a value unit in the "height" attribute (i.e. "100%"):
					_style.height = `calc(${_style.height} - 6px)`;
				}
			}

			if(typeof(_style.width) == 'string' || typeof(_style.height) == 'string') size_class = 'relative_size_dragger';
		}

		let dd_classes = ['image_uploader', 'gui_pos_rel'];
		if(is_frontend) dd_classes.push('is_frontend');
		if(reduce_placeholder) dd_classes.push('with_dragger');
		if(this.state.image != '' && this.state.image != this.reset_value) dd_classes.push('no_img');
		if(dd_size == 'full_w') dd_classes.push('small_drag_message');

		const has_error = (this.props.errors && this.props.errors[this.props.name]) ? this.props.errors[this.props.name] : (this.state.error != null ? this.state.error : false);

		const small_input = this.props?.small_input ?? true;

		let display_custom_dragging_instructions = (this.props.display_custom_dragging_instructions != undefined) ? this.props.display_custom_dragging_instructions : false;

		let preview = this.props?.preview ?? true;
		let classname = this.props?.classname ?? ['input', 'file'];

		let disabled = this.props?.disabled ?? false;
		if(disabled) classname.push('disabledField');

		if(small_input) {
			classname.push('is_small_input');
			if(display_custom_dragging_instructions === false) display_custom_dragging_instructions = "Upload image";
			preview = false;
		}
		if(size_class) classname.push(size_class);
		classname = parseClasses(classname.join(" "), this.props._class, 'imageuploader');

		let accepted_formats = false;
		if(this.props._accepted_formats != undefined) {
			let accepted = [];
			for(let format in this.props._accepted_formats) {
				accepted.push(this.props.intl.formatMessage({id:this.props._accepted_formats[format]}));
			}
			accepted_formats = accepted.join(", ");
		}

		const enable_cancel = this.props?.enable_cancel ?? false;
		const enable_actions = this.props?.enable_actions ?? true;
		const floating_edit_button = this.props?.floating_edit_button ?? false;
		const display_dragging_instructions = (!display_custom_dragging_instructions) ? ((this.props.display_dragging_instructions != undefined) ? this.props.display_dragging_instructions : true) : false;

		const accepted_formats_position = (this.props.accepted_formats_position != undefined) ? this.props.accepted_formats_position : ((!window.is_rtl) ? 'mod_align_right' : 'mod_align_left');

		if(this.props.element != undefined && this.props.only_element != undefined && this.props.only_element) {
			return (
				<DropzoneComponent ref={(e=>{this.dropzoneRef = e})} config={this.componentConfig} eventHandlers={this.eventHandlers} djsConfig={this.djsConfig}  >
					<div class="dz-message">
						<span>{this.props.element}</span>
					</div>
				</DropzoneComponent>
			);
		}

		const is_uploading = this.props?.uploading ?? false;
		const is_upload_finished = (this.props.progress != undefined && this.props.progress > 99.5) ? true : false;

		let upload_styles = null;
		if(preview) {
			upload_styles = { backgroundImage:`url(${this.state.image})` };
			if(this.state.image != undefined && this.state.image.indexOf('no-foto') > -1) upload_styles.backgroundSize = 'cover';
		}

		const PreviewComponent = (is_builder) ? FloatingLayer : FloatingLayerPublic;
		return (
			<div class={'react_field type_file' + ((this.props._field_class != undefined) ? ' ' + this.props._field_class : '')} style={_field_styles} onMouseEnter={(this.props.onMouseEnter != undefined) ? this.props.onMouseEnter : null} onMouseLeave={(this.props.onMouseLeave != undefined) ? this.props.onMouseLeave : null} onFocus={(this.props.onFocus != undefined) ? this.props.onFocus : null} onBlur={(this.props.onBlur != undefined) ? this.props.onBlur : null} onClick={(this.props.onClick != undefined) ? this.props.onClick : null}>
				<div class={classname + ((has_error) ? ' has_error' : '')}>
					<FieldLabel
						{...this.props.label_props}
						name={this.props.name}
						addition={_extra}
						autotranslate={this.props.autotranslate}
					>{this.props.children}</FieldLabel>

					<div class="field_container this_input">
						<figure id={this.uploader_id} class={dd_classes.join(" ")} style={_style}>
							{(this.props.element == undefined) ? (
								<DropzoneComponent ref={(e=>{this.dropzoneRef = e})} config={this.componentConfig} eventHandlers={this.eventHandlers} djsConfig={this.djsConfig}>
									{(this.state.image != undefined && this.state.image != '' && this.state.image != this.reset_value && !placeholder_images.includes(this.state.image)) ? (
										<div style={upload_styles} class="uploader_preview img_preview_bg">
											<div class="dz-message has_file">
												{(this.has_preview_file()) ? (
													<span>[ {i18n("File uploaded")} ]</span>
												) : (
													(!preview) ? (
														<span>[ {i18n("Image uploaded")} ]</span>
													) : (
														<span />
													)
												)}
											</div>
										</div>
									) : (
										<div style={{height:'100%'}}>
											<div class="dz-message">
												{(display_dragging_instructions && preview) && (
													<span class="drag_message">
														<span class="original_color_item">{this.props.intl.formatMessage({id:"Click to Select and Upload File"})}</span>
														<span class="original_color_item gui_only_desktop">{this.props.intl.formatMessage({id:"or"})}</span>
														<span class="original_color_item gui_only_desktop">{this.props.intl.formatMessage({id:"Drag and Drop File"})}</span>
													</span>
												)}
												{(display_custom_dragging_instructions) && (
													<span class="drag_message">
														<span class="original_color_item">{this.props.intl.formatMessage({id:display_custom_dragging_instructions})}</span>
													</span>
												)}
											</div>

											<img src={window.cdn_url + 'img/blank.png'} width="100%" height="100%" />
										</div>
									)}
								</DropzoneComponent>
							) : ( 
								<DropzoneComponent ref={this.dropzoneRef} config={this.componentConfig} eventHandlers={this.eventHandlers} djsConfig={this.djsConfig}>
									<div class="dz-message">
										{this.props.element}
									</div>
								</DropzoneComponent>
							)}

							{(enable_cancel !== false) && (
								<ButtonCollection style={{position:'absolute', top:'15px', right:'15px'}}>
									<SquaredButton
										onClick={enable_cancel.bind(this)}
										icon='knk-off transparentButton'
										aria-label="Cancel"
									/>
								</ButtonCollection>
							)}

							{(this.state.image != '' && this.state.image != this.reset_value && this.state.image != null) && (
								<ButtonCollection _class={{ other:'floating_actions gui_flex_start' }}>
									{(this.has_preview_file()) ? (
										<SquaredButton
											_href={this.props.preview_file}
											_target="_blank"
											icon={`knk-links ${(is_frontend === false) ? 'mainBgButton' : 'transparentButton'}`}
											aria-label="Preview file"
										/>
									) : (
										(!preview) && (
											<SquaredButton
												icon={`knk-visible ${(is_frontend === false) ? 'mainBgButton' : 'transparentButton'}`}
												onClick={() => this.setState({ display_uploaded_image:true })}
												aria-label="Display image"
											/>
										)
									)}
									{(enable_actions) && (
										<DeleteButton
											squared={true}
											icon={`knk-delete ${(is_frontend === false) ? 'mainBgButton' : 'transparentButton'}`}
											onClick={this.remove.bind(this)}
											_position={this.props?.delete_position ?? null}
										/>
									)}
								</ButtonCollection>
							)}

							{(is_uploading) && (
								<div class="uploading_media is_fullscreen relative_to_container">
									<Spinner
										force_bg={true}
										hide_spinner={is_upload_finished}
										autotranslate={false}
									>{(is_upload_finished) ? `${i18n("Finishing")}...` : null}</Spinner>

									<div class="uploading_progress_bar">
										<span class={`bar gui_is_animated${(is_upload_finished) ? ' is_done' : ''}`} style={{width:`${this.props?.progress}%`}} />
									</div>
								</div>
							)}
						</figure>

						{(has_error) && (
							<FieldErrorMessage error_msg_position_class={this.props.error_msg_position_class}>{has_error}</FieldErrorMessage>
						)}

						{(this.props.recommendations != undefined && this.props.recommendations != '') && (
							<div class="gui_field_recommendations">{this.props.recommendations}</div>
						)}

						{(this.props.after_component != undefined) && (
							<span class="label_additional_msg gui_after_message whole_contents">{this.props.after_component}</span>
						)}

						{(accepted_formats) && (
							<div class={'gui_after_message ' + accepted_formats_position}>{this.props.intl.formatMessage({id:"Valid formats"})}: {accepted_formats}</div>
						)}
					</div>
				</div>

				{(floating_edit_button) && (
					<div class="floating_edit_button">
						<SquaredButton
							onClick={() => this.emulateClick()}
							icon='knk-edit'
							_class={{ other:'gui_small_icon' }}
							aria-label="Edit"
						/>
					</div>
				)}

				{(this.state.display_uploaded_image != false) && (
					<PreviewComponent
						_class={{size:'small'}}
						contents_style={{maxWidth:'400px', width:'auto', minWidth:'1px'}}
						backButton={() => this.setState({ display_uploaded_image:false })}
					>
						<div class="is_not_padded without_actions">
							<img src={this.state.image} width="100%" alt="" />
						</div>
					</PreviewComponent>
				)}

				{(this.props.loading_message != undefined) && (
					<span class="is_fullscreen relative_to_container">
						<Spinner>{this.props.loading_message}</Spinner>
					</span>
				)}
			</div>
		);
	}
}

export default injectIntl(ImageUploader);